// extracted by mini-css-extract-plugin
module.exports = {"cookieWrapper":"main--cookieWrapper--1CiQ2","left":"main--left--psO_t","center":"main--center--1FsNh","right":"main--right--8fJXA","close":"main--close--3w8zT"};